import React, { useState } from "react";
import { styled } from "@glitz/react";
import { GrCopy } from "react-icons/gr";
import { spacing, fontSize, fontWeight, grey, lightGrey } from "../theme";

const SWISH_NUMBER = "1230821637";

interface SwishOptionProps {
  amount: string;
  message: string;
}

const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};

const SwishOption: React.FC<SwishOptionProps> = ({ amount, message }) => {
  const [copied, setCopied] = useState<"none" | "number" | "amount" | "message">("none");

  const handleCopy = async (text: string, key: "number" | "amount" | "message") => {
    const ok = await copyToClipboard(text);
    setCopied(ok ? key : "none");
    if (ok) setTimeout(() => setCopied("none"), 2000);
  };

  return (
    <Wrapper>
      <Row>
        <Label>Swish-nummer</Label>
        <ValueRow>
          <Value>{SWISH_NUMBER}</Value>
          <CopyButton type="button" onClick={() => handleCopy(SWISH_NUMBER, "number")} title="Kopiera nummer">
            <GrCopy />
            {copied === "number" && <CopiedLabel>Kopierat!</CopiedLabel>}
          </CopyButton>
        </ValueRow>
      </Row>
      <Row>
        <Label>Belopp</Label>
        <ValueRow>
          <Value>{amount} kr</Value>
          <CopyButton type="button" onClick={() => handleCopy(amount, "amount")} title="Kopiera belopp">
            <GrCopy />
            {copied === "amount" && <CopiedLabel>Kopierat!</CopiedLabel>}
          </CopyButton>
        </ValueRow>
      </Row>
      <Row>
        <Label>Meddelande / Ordernummer</Label>
        <ValueRow>
          <Value>{message}</Value>
          <CopyButton type="button" onClick={() => handleCopy(message, "message")} title="Kopiera ordernummer">
            <GrCopy />
            {copied === "message" && <CopiedLabel>Kopierat!</CopiedLabel>}
          </CopyButton>
        </ValueRow>
      </Row>
    </Wrapper>
  );
};

const Wrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: spacing.m,
});

const Row = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: spacing.xxs,
});

const ValueRow = styled.div({
  display: "flex",
  alignItems: "center",
  gap: spacing.s,
});

const Label = styled.span({
  fontSize: fontSize.s,
  fontWeight: fontWeight.bold,
});

const Value = styled.span({
  fontSize: fontSize.m,
  fontWeight: fontWeight.regular,
});

const CopyButton = styled.button({
  display: "inline-flex",
  alignItems: "center",
  gap: spacing.xs,
  padding: { x: spacing.s, y: spacing.xs },
  fontSize: fontSize.s,
  backgroundColor: "transparent",
  border: { xy: { style: "solid", color: grey, width: "1px" } },
  borderRadius: "6px",
  cursor: "pointer",
  ":hover": {
    backgroundColor: lightGrey,
  },
});

const CopiedLabel = styled.span({
  fontSize: fontSize.xs,
  color: "#1C8567",
  fontWeight: fontWeight.bold,
});

export default SwishOption;
